import React from 'react';
import { Building2, Briefcase } from 'lucide-react';
import { OnboardingFormData } from '../OnboardingWizardContent';

interface Props {
  data: OnboardingFormData;
}

const StepCompanyDetails: React.FC<Props> = ({ data }) => {
  const industryLabels: Record<string, string> = {
    accounting: 'Accounting & Tax',
    legal: 'Legal Services',
    financial: 'Financial Advisory',
    insurance: 'Insurance',
    realestate: 'Real Estate',
    healthcare: 'Healthcare',
    consulting: 'Consulting',
    other: 'Other',
  };

  return (
    <div className="space-y-6">
      <p className="text-muted-foreground">
        Please confirm your company details below. If anything is incorrect, 
        please contact us at{' '}
        <a href="mailto:connect@thinktomorrow.ai" className="text-brand-teal hover:underline">
          connect@thinktomorrow.ai
        </a>
      </p>

      <div className="grid gap-6">
        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-brand-teal/10 rounded-lg">
              <Building2 className="h-5 w-5 text-brand-teal" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Company Name</p>
              <p className="text-lg font-medium text-foreground">{data.companyName}</p>
            </div>
          </div>
        </div>

        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-brand-teal/10 rounded-lg">
              <Briefcase className="h-5 w-5 text-brand-teal" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Industry</p>
              <p className="text-lg font-medium text-foreground">
                {industryLabels[data.industry] || data.industry}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-brand-teal/5 border border-brand-teal/20 rounded-lg p-4">
        <p className="text-sm text-card-foreground">
          <strong>💡 Tip:</strong> Your assistant will be customized based on your industry 
          to provide the most relevant and compliant responses.
        </p>
      </div>
    </div>
  );
};

export default StepCompanyDetails;
